export default __webpack_public_path__ + "static/media/1731.b167a3ce.png";